/** This function can be called in default switch cases on union type for cases which should not happen despite being representable */
export function assertUnhandled(message: string, value: any): never {
  throw { message, value };
}
